import Vue from 'vue'
import PreviewVideo from "./PreviewVideo.vue";
const PreviewVideoConstructor = Vue.extend(PreviewVideo)

export const previewVideo = (options) => {
  const instance = new PreviewVideoConstructor({
    data: {
      ...options,
    }
  })

  document.body.appendChild(instance.$mount().$el)

  instance.$watch('visible', () => {
    if (!instance.visible) {
      setTimeout(() => {
        if (instance.$el && instance.$el.parentNode === document.body) {
          document.body.removeChild(instance.$el)
        }
      }, 300)
    }
  })

  return instance
}
